/** @format */
import { Field, ErrorMessage } from "formik";
import Error from "./FormError";

const Select = ({ label, name, type, options,required }) => {
  const star = ["*"];

  return (
    <div className="form__control">
      <label htmlFor={name}>
        {label} <span className="label__required"> {required && star[0]} </span>
      </label>
      <Field as={type} name={name}>
        {options.map((option) => {
          return (
            <option key={option.key} value={option.value}>
              {option.key}
            </option>
          );
        })}
      </Field>
      <ErrorMessage name={name} component={Error} />
    </div>
  );
};

export default Select;
